(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/views/statteamplayerstatistics.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/views/statteamplayerstatistics.js'); 

(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamPlayerStatistics = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatTeamPlayerStatistics',
    viewId: 'statistik',
    PAGE_SIZE: 10,
    firstTime: true,
    SPORT_HOCKEY: 'sport-hockey',
    teamName: '',
    events: {
      'change #playerStatsLeagueFilter': 'selectMenu',
      'change #playerStatsTeamFilter': 'selectMenu',
      'change #playerStatsTypeFilter': 'selectMenu',
      'click #playerStatsQuantity': 'moreButton',
      'change #teamStatsTypeFilter': 'selectMenu'
    },
    filters: {
      playerStatsTeamFilter: {
        filterValues: {
          all: { name: 'Alla lag', selected: false, id: 'all' }
        },
        selectedKey: ''
      },
      playerStatsTypeFilter: {
        filterValues: {},
        selectedKey: ''
      },
      playerStatsQuantity: 0,
      playerStatsMoreExists: true
    },
    initialize: function(options) {
      this.resetFilters();
      this.modelReference = options.modelReference;
      this.options = options.options;
      this.filters.playerStatsQuantity = this.PAGE_SIZE;
    },
    update: function(model) {
      this.model = model;
      if (!this.internalChange) {
        this.teamId = this.model.get('originalTeamId');
      }
      this.internalChange = false;
      this.resetFilters();
      this.render({});
    },
    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },
    render: function() {
      if (!this.model) return this;
      if (
        !this.model.get('sport') ||
        (this.model.get('error') && !this.model.get('fetched'))
      ) {

        if (!this.model.get('pending')) {
          this.$el.html(svs.statistics.statistics.templates.nodata({}));
        }

        return this;
      }

      if (
        this.retrieveSportById(this.model.get('sport').id) === this.SPORT_HOCKEY
      ) {
        return this;
      }

      var _self = this,
        componentFile = 'stat-team-player-statistics',
        id = null,
        theme;

      id = this.model.get('sport').id;

      theme = new svs.sport.themeLoader({
        sport: id
      });
      theme.load(function(template, init) {
        if (!template) {
          return _self.$el.html(svs.statistics.statistics.templates.nodata({}));
        }
        _self.template = template;

        _self.$el.html(_self.template(_self.applyFilters()));
        if (
          Object.prototype.hasOwnProperty.call(_self.options.params, 'parent')
        ) {
          _self.options.params.parent.trigger('resize');
        }
        if (init) {
          init(componentFile);
        }
      }, componentFile);
      return this;
    },
    applyFilters: function() {
      var players = [];

      this.setupPlayerStatTeamDropDownModule();
      this.setupPlayerStatDropDownModule();
      players = this.setupPlayerStatModule();
      this.checkForKeysByTeams();

      return {
        players: players,
        teamName: this.teamName,
        filters: this.filters,
        sortedTeams: this.sortedTeamList
      };
    },
    selectMenu: function(event) {
      var selectedVal = $(event.currentTarget).val();
      this.filters[$(event.currentTarget).attr('id')].selectedKey = selectedVal;

      _.each(
        this.filters[$(event.currentTarget).attr('id')].filterValues,
        function(filterValue) {
          filterValue.selected = false;
        }
      );

      this.filters[$(event.currentTarget).attr('id')].filterValues[
        selectedVal
      ].selected = true;

      if ($(event.currentTarget).attr('id') === 'playerStatsTeamFilter') {
        this.filters.playerStatsTypeFilter.filterValues = {};
        _.each(this.sortedTeamList, function(sortedTeam) {
          sortedTeam.selected = false;
          if (selectedVal === sortedTeam.id) {
            sortedTeam.selected = true;
          }
        });
        if (selectedVal !== 'all') {
          this.internalChange = true;
          this.teamId = selectedVal;
          this.model.setCurrentTeam(this.teamId);
          return;
        }
      }
      this.filters.playerStatsQuantity = this.PAGE_SIZE;
      this.render({});
    },
    setupPlayerStatTeamDropDownModule: function() {
      var playerStatistics = this.model.get('playerStatistics'),
        self = this;
      if (this.firstTime) {
        if (!this.teamId) {
          var pos = 0;
          if ((((playerStatistics || {}).byTeam || {})[pos] || {}).id) {
            this.teamId = playerStatistics.byTeam[pos].id;
          }
        }
        self.filters.playerStatsTeamFilter.selectedKey = this.teamId;
      }
      if (_.size(this.filters.playerStatsTeamFilter.filterValues) < 2) {
        this.sortedTeamList = [];
        this.sortedTeamList.push(
          self.filters.playerStatsTeamFilter.filterValues.all
        );

        var isHockey =
          this.retrieveSportById(this.model.get('sport').id) ===
          this.SPORT_HOCKEY;
        if ((playerStatistics || {}).byTeam) {
          var foundSelectedTeam = false;
          _.each(playerStatistics.byTeam, function(teamstat) {
            if (self.firstTime && teamstat.id === self.teamId) {
              self.firstTime = false;
              foundSelectedTeam = !isHockey;
              self.filters.playerStatsTeamFilter.filterValues[teamstat.id] = {
                name: teamstat.mediumName,
                selected: true,
                id: teamstat.id
              };
              self.sortedTeamList.push({
                name: teamstat.mediumName,
                selected: !isHockey,
                id: teamstat.id
              });
              self.teamName = teamstat.mediumName;
            } else {
              self.filters.playerStatsTeamFilter.filterValues[teamstat.id] = {
                name: teamstat.mediumName,
                selected: false,
                id: teamstat.id
              };
              self.sortedTeamList.push({
                name: teamstat.mediumName,
                selected: false,
                id: teamstat.id
              });
            }
          });
          if (!foundSelectedTeam) {
            this.filters.playerStatsTeamFilter.selectedKey = 'all';
          }
        }
      }
    },
    setupPlayerStatDropDownModule: function() {
      var playerStatistics = this.model.get('playerStatistics'),
        self = this,
        keystat = [];
      if (_.size(this.filters.playerStatsTypeFilter.filterValues) < 1) {
        if (self.filters.playerStatsTeamFilter.selectedKey === 'all') {
          keystat = playerStatistics.byKey;
          self.createPlayerStatsDropDownItems(keystat);
        } else {
          if ((playerStatistics || {}).byTeam) {
            _.each(playerStatistics.byTeam, function(teamStat) {
              if (
                self.filters.playerStatsTeamFilter.selectedKey === teamStat.id
              ) {
                keystat = teamStat.byKey;
                self.createPlayerStatsDropDownItems(keystat, teamStat);
              }
            });
          }
        }
      }
    },
    createPlayerStatsDropDownItems: function(keystat, teamStat) {
      var self = this,
        playerStatistics = teamStat
          ? teamStat
          : this.model.get('playerStatistics');

      self.filters.playerStatsTypeFilter.selectedKey = '';
      for (var i in keystat) {
        if (Object.prototype.hasOwnProperty.call(keystat, i)) {
          self.filters.playerStatsTypeFilter.filterValues[i] = {
            key: i,
            name: playerStatistics.keys[i].description
              ? playerStatistics.keys[i].description
              : playerStatistics.keys[i],
            sortMultiplicator: -1,
            selected: false,
            sortIndex: this.findSortOrderByKey(
              playerStatistics.keys[i].description
                ? playerStatistics.keys[i].description
                : playerStatistics.keys[i]
            )
          };
        }
      }
      self.filters.playerStatsTypeFilter.filterValues = this.sortStatsTypeFilter(
        self.filters.playerStatsTypeFilter.filterValues
      );
    },
    setupPlayerStatModule: function(players) {
      var self = this;
      var playerStatistics = this.model.get('playerStatistics'),
        byPlayer = playerStatistics.byPlayer,
        filteredPlayersByKeys = [];
      players = playerStatistics.players;

      if (this.filters.playerStatsTeamFilter.selectedKey !== 'all') {
        _.each(playerStatistics.byTeam, function(teamstat) {
          if (teamstat.id === self.filters.playerStatsTeamFilter.selectedKey) {
            if (_.isObject(teamstat.byKey)) {
              filteredPlayersByKeys =
                teamstat.byKey[self.filters.playerStatsTypeFilter.selectedKey];
            }
            players = teamstat.players;
            byPlayer = teamstat.byPlayer;
          }
        });
      } else {
        players = playerStatistics.players;
        byPlayer = playerStatistics.byPlayer;

        if (players) {
          filteredPlayersByKeys =
            playerStatistics.byKey[
              self.filters.playerStatsTypeFilter.selectedKey
            ];
        }
      }

      if (!filteredPlayersByKeys) {
        filteredPlayersByKeys = [];
      }
      players = this.findPlayersById(filteredPlayersByKeys, players, byPlayer);

      players = _.sortBy(players, function(player) {
        return player.lastName;
      });

      players = _.sortBy(players, function(player) {
        return (
          player.valueText *
          self.filters.playerStatsTypeFilter.filterValues[
            self.filters.playerStatsTypeFilter.selectedKey
          ].sortMultiplicator
        );
      });

      this.filters.playerStatsMoreExists =
        _.size(players) > this.filters.playerStatsQuantity;

      players = _.first(players, this.filters.playerStatsQuantity);

      var position = 1;
      _.each(players, function(player) {
        player.position = position++;
      });

      return players;
    },
    removeEmptyKeys: function(keystat) {
      var oTempKeyList = {};
      for (var i in keystat) {
        if (keystat[i].length > 0) {
          oTempKeyList[i] = keystat[i];
        }
      }
      return oTempKeyList;
    },
    sortStatsTypeFilter: function(playerStatsTypeFilter) {
      var tempFilterList = [];
      var i;
      for (i in playerStatsTypeFilter) {
        if (Object.prototype.hasOwnProperty.call(playerStatsTypeFilter, i)) {
          tempFilterList.push(playerStatsTypeFilter[i]);
          playerStatsTypeFilter[i] = null;
          delete playerStatsTypeFilter[i];
        }
      }
      tempFilterList = _.sortBy(tempFilterList, function(tempFilter) {
        return tempFilter.sortIndex;
      });
      tempFilterList = _.filter(tempFilterList, function(tempFilter) {
        return tempFilter.sortIndex >= 0;
      });
      playerStatsTypeFilter = {};

      var foundGoal = false;
      for (i = 0; i < tempFilterList.length; i++) {
        playerStatsTypeFilter[tempFilterList[i].key] = tempFilterList[i];

        if (
          playerStatsTypeFilter[tempFilterList[i].key].name ===
            this.model.GOALS &&
          !foundGoal
        ) {
          foundGoal = true;
          playerStatsTypeFilter[tempFilterList[i].key].selected = true;
          this.filters.playerStatsTypeFilter.selectedKey =
            tempFilterList[i].key;
        }
      }

      if (!foundGoal) {
        for (i in playerStatsTypeFilter) {
          if (Object.prototype.hasOwnProperty.call(playerStatsTypeFilter, i)) {
            playerStatsTypeFilter[i].selected = true;
            this.filters.playerStatsTypeFilter.selectedKey =
              playerStatsTypeFilter[i].key;
            break;
          }
        }
      }

      return playerStatsTypeFilter;
    },
    findSortOrderByKey: function(oStatKey) {
      var sortIndex = -1;
      if (oStatKey === this.model.GOALS) sortIndex = 0;
      else if (oStatKey === this.model.ASSISTS) sortIndex = 1;
      else if (oStatKey === this.model.YELLOW_CARDS) sortIndex = 2;
      else if (oStatKey === this.model.TOTAL_RED_CARDS) sortIndex = 3;
      else if (oStatKey === this.model.YELLOW_OR_RED_CARDS) sortIndex = -1;
      else if (oStatKey === this.model.RED_CARDS) sortIndex = -1;
      else if (oStatKey === this.model.MATCHES_PLAYED) sortIndex = 4;
      else if (oStatKey === this.model.SUBSTITUTIONS_IN) sortIndex = 5;
      else if (oStatKey === this.model.SUBSTITUTIONS_OUT) sortIndex = 6;
      else if (oStatKey === this.model.STARTING_XI) sortIndex = 7;
      return sortIndex;
    },

    findPlayersById: function(
      filteredPlayersByKey,
      totalPlayers,
      byPlayerStats
    ) {
      var value = 0,
        playerId = null,
        filteredJoinedPlayersList = [],
        goals = null,
        assists = null,
        points = null;

      for (var i = 0; i < filteredPlayersByKey.length; i++) {
        playerId = filteredPlayersByKey[i].playerId;
        value = this.formatValue(filteredPlayersByKey[i].value + '');

        goals = this.findStatKeysByPlayer(
          byPlayerStats[playerId],
          'goalsIntournament'
        );
        if (!goals) {
          goals = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'goalsForTeam'
          );
        }

        if (!goals) {
          goals = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'totalGoals'
          );
        }

        assists = this.findStatKeysByPlayer(
          byPlayerStats[playerId],
          'assistsInTournament'
        );
        if (!assists) {
          assists = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'assistsForTeam'
          );
        }

        if (!assists) {
          assists = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'totalAssists'
          );
        }

        if (!points) {
          points = this.findStatKeysByPlayer(
            byPlayerStats[playerId],
            'totalPoints'
          );
        }

        for (var t = 0; t < totalPlayers.length; t++) {
          if (totalPlayers[t].id === playerId) {
            filteredJoinedPlayersList.push({
              playerId: playerId,
              valueText: value,
              name: totalPlayers[t].name,
              firstName: totalPlayers[t].firstName,
              lastName: totalPlayers[t].lastName,
              team: { mediumName: 'test' },
              totSavedPercent: null,
              goals: goals ? goals : '0',
              assists: assists ? assists : '0',
              points: points ? points : '0'
            });
          }
        }
      }
      return filteredJoinedPlayersList;
    },
    retrieveSportById: function(sportId) {
      return new svs.sport.themeLoader().retrieveSportById(sportId);
    },
    formatValue: function(value) {
      return svs.utils.format.formatValueToCommaStr(value, 2, false);
    },
    findStatKeysByPlayer: function(playerData, needle) {
      var statResult = null;
      _.each(playerData, function(data) {
        if (data.key === needle) {
          statResult = data.value;
        }
      });
      return statResult;
    },
    checkForKeysByTeams: function() {
      var playerStatistics = this.model.get('playerStatistics');
      var isAvailable = false;
      if ((playerStatistics || {}).byTeam) {
        _.each(playerStatistics.byTeam, function(teamStat) {
          if (teamStat.byKey) {
            isAvailable = true;
          }
        });
      }
      if (!isAvailable) {
        this.sortedTeamList = [];
      }
    },
    moreButton: function(event) {
      this.filters[$(event.currentTarget).attr('id')] += this.PAGE_SIZE;
      this.render({});
    },
    resetFilters: function() {
      this.filters.playerStatsTeamFilter = {
        filterValues: {
          all: { name: 'Alla lag', selected: false, id: 'all' }
        },
        selectedKey: 'all'
      };
      this.filters.playerStatsTypeFilter.filterValues = {};
      this.firstTime = true;
      this.sortedTeamList = [];
    },
    onDestroy: function() {
      this.undelegateEvents();
      if (this.modelReference) {
        this.modelReference.off('change', this.render, this);
      }
      this.remove();
      Backbone.View.prototype.remove.call(this);
    }
  });
})(Backbone, _, svs);

 })(window);